import React from "react";
import { Text, ExternalLink } from "@netapp/bxp-design-system-react";

export const ErrorMessageWithLink = ({ message, hyperLink, linkText }) => {
    return <Text> { message } {" "}
        <ExternalLink variant="text" color="secondary" href={ hyperLink } includeArrow={true} target="_blank"> { linkText } </ExternalLink>
    </Text>
}
